import { useMutation } from '@tanstack/react-query';
import attachCredits from '../../api/credits/attach-credits';

type UseAttachCreditsArgs = {
    refetchCart: () => Promise<void>;
};

const useAttachCredits = ({ refetchCart }: UseAttachCreditsArgs) =>
    useMutation({
        mutationFn: attachCredits,
        // TODO FE-249 Stage 2: swap for refetchCart(queryClient) once the cart moves to React Query
        onSuccess: refetchCart
    });

export default useAttachCredits;
